import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CaseNoteEditEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const caseNoteEditEntryPoint: EntryPoint<CaseNoteEditEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<CaseNoteEditEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-case-note-edit" */ './CaseNoteEditPage.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
